<!--Recursive element which populates container with all documents 
    in their proper categories.
-->

<template>
  <div>
    <div class="mb-3" :style="indent" v-if="item.type == 'category'">
      <h6 class="sub-title text-uppercase text-left font-weight-bold default">{{item.title}}</h6>
    </div>
    <ul class="list-unstyled" style="list-style-type: none;" v-if="item.type == 'document'">
      <li :style="indent" class="text-left">
        <a :href="item.document.download_url">
          <mdb-icon icon="file" class="pl-1 pr-2 d-inline-block"></mdb-icon>
          {{item.title}}
        </a>
      </li>
    </ul>
    <tree
      class="item"
      :depth="depth + 1"
      v-for="(child, index) in item.documents"
      :key="index"
      :item="child"
    ></tree>
  </div>
</template>

<script>
import { mdbIcon} from "mdbvue";
export default {
  name: "tree",
  components: { mdbIcon },
  props: {
    type: {
      type: [String],
      default: "departments.DepartmentTabPage"
    },
    fields: {
      type: [String],
      default:
        "title,content,categories,tags,blog_authors,custom_title,banner_image,parent_id"
    },
    item: {
      type: [Object]
    },
    depth: {
      type: [Number]
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: {
    indent() {
      var px = this.depth * 20;
      return "margin-left:" + px + "px";
    }
  },
  methods: {},
  watch: {},
  mounted() {}
};
</script>

<style scoped>
ul {
  padding-left: 1em;
  line-height: 1.5em;
  list-style-type: dot;
}
</style>

